<section class="main">
  <ng-container>
    <mat-toolbar>
      <div fxLayout="row" fxFlex="100" fxLayoutGap="0.5em">
        <div
          fxFlex.xl="12"
          [fxFlex]="isTablet ? 30 : 16"
          fxFlex.xs="10"
          fxLayoutAlign="start center"
          fxLayout="row"
        >
          <app-sidebar-top
            [logo]="customerLogo"
            *ngIf="(showSearch && !isTablet) || !isMobile"
          ></app-sidebar-top>
        </div>
        <div
          fxFlexOffset="3"
          [fxFlex]="isTablet ? 58 : 43"
          fxFlex.xs="81"
          fxFlex.gt-lg="44"
        >
          <!-- <app-search-autocomplete *ngIf="showSearch"> </app-search-autocomplete> -->
        </div>
        <div
          [fxFlex]="isTablet ? 7 : 40"
          fxFlex.xs="10"
          fxLayout="row"
          fxLayoutAlign="end center"
          fxLayoutGap="5px"
        >
          <ng-container *ngFor="let button of buttonList">
            <button
              mat-raised-button
              (click)="setAction(button.function)"
              *ngIf="isDesktopDevice"
            >
              <mat-icon>{{ button.icon }}</mat-icon
              >{{ button.label }}
            </button>
          </ng-container>
          <div
            class="actions"
            [matMenuTriggerFor]="menu"
            *ngIf="actionList.length > 0 || !isDesktopDevice"
          >
            <!-- Menu icon -->
            <!--             <button id="actionsMenu" mat-icon-button aria-label="Actions menu">
              <mat-icon>more_vert</mat-icon>
            </button>
 -->
          </div>
          <ng-container *ngIf="isDesktopDevice">
            <button mat-icon-button>
              <mat-icon class="setting-icon" fontSet="material-icons-solid"
                >notifications</mat-icon
              >
            </button>
            <div class="notification settings">
              <app-user-menu [avatar]="avatar"></app-user-menu>
            </div>
          </ng-container>
        </div>
      </div>
    </mat-toolbar>
  </ng-container>
</section>

<mat-menu #menu="matMenu" [overlapTrigger]="false">
  <app-actions-menu></app-actions-menu>
</mat-menu>
